export enum TimeOffCommentTypesEnum {
    DENIED = 'denied',
}
